import * as React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogTitle, IconButton, styled } from '@mui/material'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2)
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1)
    }
}))

interface BootstrapDialogTitleProps {
    children?: React.ReactNode
    onClose: () => void
}

const BootstrapDialogTitle = ({ children, onClose, ...other }: BootstrapDialogTitleProps) => {
    return (
        <DialogTitle id='customized-dialog-title' sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose && (
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}>
                    <CloseIcon />
                </IconButton>
            )}
        </DialogTitle>
    )
}

export { BootstrapDialog, BootstrapDialogTitle }
